import React from 'react'
import './FourItem.css'

export const FourItem = (props) => {
  return (
    <div className='four__item'>
        {props.children}
    </div>
  )
}

